import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { BrowserRouter } from 'react-router';
import gsap from 'gsap';
import { CSSPlugin } from 'gsap/CSSPlugin';
import { CustomEase } from 'gsap/CustomEase';
import './components.css';
import './mobile.css';
import GradientBox from './components/GradientBox/GradientBox';
import WordpressDispatcher from './components/WordpressDispatcher';
import Header from './components/Header/Header';
import PageContent from './components/Page/PageContent';
import Router from './components/Router/Router';
import ShaderAnimation from './components/ShaderAnimation/ShaderAnimation';
import EditorPreview from './components/Editor/EditorPreview';
import useEditorStore from './components/Editor/EditorStore';
import Resizer from './components/Resizer';
import 'modern-normalize/modern-normalize.css';
import PageFeedback from './components/Page/PageFeedback';
import { useSafariPageReload } from './utils';
import BackgroundSwitch from './components/ShaderAnimation/BackgroundSwitch';
import SolutionsBackgroundSwitch from './components/ShaderAnimation/SolutionsBackgroundSwitch';
import ProductBackgroundSwitch from './components/ShaderAnimation/ProductBackgroundSwitch';
import { isWindows } from './components/globalUtils';
import GDPR from './components/GDPR/GDPR';
import PageMetadata from './components/Meta/PageMetadata';
function App() {
    const { editCurve } = useEditorStore();
    useSafariPageReload();
    const mounted = useRef(false);
    useEffect(() => {
        if (mounted.current)
            return;
        mounted.current = true;
        gsap.registerPlugin(CSSPlugin);
        gsap.registerPlugin(CustomEase);
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }
        if (isWindows) {
            document.documentElement.style.overflowX = 'hidden';
        }
        const wrapper = document.querySelector('.page-wrapper');
        if (wrapper) {
            wrapper.style.opacity = '1';
        }
    }, []);
    return (_jsxs(BrowserRouter, { children: [_jsx(WordpressDispatcher, {}), _jsx(PageMetadata, {}), _jsx(Router, {}), _jsx(Resizer, {}), _jsx(GradientBox, {}), _jsx(BackgroundSwitch, { children: _jsx(ShaderAnimation, { displayedCurve: editCurve, editorMode: !!editCurve }) }), _jsx(SolutionsBackgroundSwitch, {}), _jsx(ProductBackgroundSwitch, {}), _jsx(Header, {}), _jsx(PageContent, {}), _jsx(PageFeedback, {}), _jsx(EditorPreview, {}), _jsx(GDPR, {})] }));
}
export default App;
